import React from "react";
import CookieConsent from "react-cookie-consent";

const CookieConsentComponent = () => {
  // Function to handle accepting cookies
  const handleAccept = () => {
    // Logic for accepting cookies can be placed here if needed
  };

  // Function to handle declining cookies
  const handleDecline = () => {
    // Logic for declining cookies can be placed here if needed
  };

  return (
    <>
      <CookieConsent
        buttonText="I accept"
        declineButtonText="Decline"
        onAccept={handleAccept}
        onDecline={handleDecline}
        cookieName="userConsent"
        style={{ background: "#2B373B", color: "white" }}
        buttonStyle={{
          backgroundColor: "#4CAF50",
          color: "white",
          fontSize: "13px",
        }}
        declineButtonStyle={{
          backgroundColor: "#f44336",
          color: "white",
          fontSize: "13px",
        }}
        enableDeclineButton
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>
    </>
  );
};

export default CookieConsentComponent;
